<template>
    <!-- Details: the node fields AddEditNode also edits. Every field is a v-model back to the editor page -->
    <div class="ep-scrim" @click="$emit('close')"></div>
    <aside class="ep-drawer" role="dialog" :aria-label="typeLabel + ' details'">
        <div class="ep-drawer-h">
            <h3>Details</h3>
            <button type="button" aria-label="Close" @click="$emit('close')"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" /></svg></button>
        </div>
        <div class="ep-drawer-b">
            <label class="ep-lbl" for="ep-name">Name</label>
            <input id="ep-name" :value="name" type="text" class="ep-name" :placeholder="'Name of this ' + typeLabel" @input="$emit('update:name', ($event.target as HTMLInputElement).value)" />
            <label class="ep-lbl">Owners</label>
            <process-owner-picker :model-value="ownerIds" @update:model-value="$emit('update:ownerIds', $event)" />
            <label class="ep-lbl">Locations</label>
            <div class="ep-chips on-drawer">
                <button v-for="loc in locationOptions" :key="loc" type="button" :class="['ep-chip', { on: locs.includes(loc) }]" :aria-pressed="locs.includes(loc)" @click="$emit('update:locs', toggled(locs, loc))">{{ loc }}</button>
            </div>
            <label class="ep-lbl">Departments</label>
            <div class="ep-chips on-drawer">
                <button v-for="dep in departmentOptions" :key="dep" type="button" :class="['ep-chip', { on: deps.includes(dep) }]" :aria-pressed="deps.includes(dep)" @click="$emit('update:deps', toggled(deps, dep))">{{ dep }}</button>
            </div>
            <template v-if="typeOptions.length">
                <label class="ep-lbl">Types</label>
                <div class="ep-chips on-drawer">
                    <button v-for="type in typeOptions" :key="type" type="button" :class="['ep-chip', { on: types.includes(type) }]" :aria-pressed="types.includes(type)" @click="$emit('update:types', toggled(types, type))">{{ type }}</button>
                </div>
            </template>
            <p class="ep-muted">These show at the top right of the document.</p>        </div>
        <div class="ep-drawer-f"><button type="button" class="btn" @click="$emit('close')">Done</button></div>
    </aside>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ProcessOwnerPicker from '@/components/ProcessOwnerPicker.vue';

export default defineComponent({
    name: 'EditorDetailsDrawer',
    components: {
        ProcessOwnerPicker
    },
    props: [ 'name', 'ownerIds', 'locs', 'deps', 'types', 'typeLabel' ],
    emits: [ 'close', 'update:name', 'update:ownerIds', 'update:locs', 'update:deps', 'update:types' ],
    // The Search Processes widget floats over the drawer's footer, so it's hidden while the drawer is open
    mounted() {
        this.$store.state.hideChatWidget = true;
    },
    unmounted() {
        this.$store.state.hideChatWidget = false;
    },
    computed: {
        // Keep values the company no longer lists so saving doesn't silently drop them
        locationOptions(): string[] {
            return this.withExtras(this.$store.state.user.locations, this.locs);
        },
        departmentOptions(): string[] {
            return this.withExtras(this.$store.state.user.departments, this.deps);
        },
        typeOptions(): string[] {
            return this.withExtras(this.$store.state.user.nodeTypes, this.types);
        }
    },
    methods: {
        withExtras(list: string[], selected: string[]): string[] {
            const options = [...(list || [])];
            for(const value of selected) {
                if(!options.includes(value)) options.push(value);
            }
            return options;
        },
        toggled(list: string[], value: string): string[] {
            return list.includes(value) ? list.filter(v => v != value) : [...list, value];
        }
    }
});
</script>
